module.exports = global["common"] = require("-!./common.js");